import { render, staticRenderFns } from "./EditOrganizationDetail.vue?vue&type=template&id=099d4cd2"
import script from "./EditOrganizationDetail.vue?vue&type=script&lang=js"
export * from "./EditOrganizationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports